import { object, array, string } from '@gogame/schemas';

import {
  COLUMN_ID,
  COLUMN_NAME,
  COLUMN_AGENCIES,
  COLUMN_INFLUENCER,
  COLUMN_COUNTRY,
  COLUMN_SOCIAL_MEDIA_PLATFORM,
  COLUMN_CATEGORY,
  COLUMN_SUB_CATEGORY,
  COLUMN_MASTER_CAMPAIGNS,
  COLUMN_TA,
  COLUMN_VIEWS_MIN,
  COLUMN_VIEWS_MAX,
  COLUMN_CPM_MIN,
  COLUMN_CPM_MAX,
  COLUMN_ENGAGEMENT,
  COLUMN_CLICKS_MIN,
  COLUMN_CLICKS_MAX,
  COLUMN_CPI_MIN,
  COLUMN_CPI_MAX,
  COLUMN_CONVERSIONS_MIN,
  COLUMN_CONVERSIONS_MAX,
  COLUMN_CONCURRENT_VIEWERS,
  COLUMN_PRICES,
  COLUMN_PRICES_WITH_FEE,
  COLUMN_SUBSCRIBERS,
  COLUMN_LAST_UPDATED_BY,
  COLUMN_LAST_UPDATED_DATE,
  COLUMN_CREATED_BY,
  COLUMN_CREATED_DATE,
} from 'scenes/Influencers/InfluencersChannels/constants';

export const columnsSchema = object({
  order: array(string()).default([
    COLUMN_ID,
    COLUMN_NAME,
    COLUMN_AGENCIES,
    COLUMN_INFLUENCER,
    COLUMN_COUNTRY,
    COLUMN_SOCIAL_MEDIA_PLATFORM,
    COLUMN_CATEGORY,
    COLUMN_SUB_CATEGORY,
    COLUMN_MASTER_CAMPAIGNS,
    COLUMN_TA,
    COLUMN_VIEWS_MIN,
    COLUMN_VIEWS_MAX,
    COLUMN_CPM_MIN,
    COLUMN_CPM_MAX,
    COLUMN_ENGAGEMENT,
    COLUMN_CLICKS_MIN,
    COLUMN_CLICKS_MAX,
    COLUMN_CPI_MIN,
    COLUMN_CPI_MAX,
    COLUMN_CONVERSIONS_MIN,
    COLUMN_CONVERSIONS_MAX,
    COLUMN_CONCURRENT_VIEWERS,
    COLUMN_PRICES,
    COLUMN_PRICES_WITH_FEE,
    COLUMN_SUBSCRIBERS,
    COLUMN_LAST_UPDATED_BY,
    COLUMN_LAST_UPDATED_DATE,
    COLUMN_CREATED_BY,
    COLUMN_CREATED_DATE,
  ]),
  collapsed: array(string()).default([]),
});
